import React, { useEffect, useState } from 'react';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { UserApi } from '../../redux/api/UserApi';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { IMonitor } from '../../types/User/IMonitor';
import createTheme from '../../styles/themes';
import * as svg from '@progress/kendo-svg-icons';
import { ListView } from '@progress/kendo-react-listview';
import { groupBy } from '@progress/kendo-data-query';
import { Card, CardFooter } from '@progress/kendo-react-layout'
import './TicketMonitor.scss';
import { PartialSpinny } from '../Nav/Spinny';
import { toast } from 'react-toastify';

const TicketMonitor: React.FC = () => {
    const navigate = useNavigate();
    const { data: ticketMonitor, isLoading } = UserApi.useGetUserMonitorQuery();
    //const [selectedItems, setSelectedItems] = useState<IMonitor[]>([]);
    const [updateItems, setUpdateItems] = useState<IMonitor[]>([]);
    const { data: profile } = UserApi.useGetUserProfileQuery();
    const [updateTicketMOnitor, { isLoading: saving }] = UserApi.useSaveMonitorMutation()
    const monitorItems: IMonitor[] = ticketMonitor || [];

    useEffect(() => {
        setUpdateItems(ticketMonitor);
    }, [ticketMonitor]);


    const onSave = () => {
        const itemsToUpdate = updateItems.filter(item => item.HasChanged);
        if (itemsToUpdate.length === 0) {
            // No items have changed, so we can just navigate back
            navigate('/');
            return;
        }

        updateTicketMOnitor(itemsToUpdate)
            .then(() => {
                // Successfully updated, navigate back
                navigate('/');
            })
            .catch((error) => {
                console.error('Error updating monitor items:', error);
                // Handle error (e.g., show a notification)
                toast.error('Failed to update monitor items. Details: ' + error.message);
            });
    }

    const itemClicked = (item: IMonitor) => {
        //Update the Active state of the item
        setUpdateItems((s) => {
            const updatedItems = s.map(selected => selected.Id === item.Id ? { ...selected, Active: !selected.Active, HasChanged: true } : selected);
            return updatedItems;
        });
    }

    const onCancel = () => {
        navigate('/'); // Navigate back to the home page
    }

    const pageThemeCSS = createTheme(profile.Body_Hex_Color, profile?.Body_Style, profile?.Body_Image_Url);

    return (

        <div style={pageThemeCSS} className='monitor-page fullscreen'>
            {(isLoading || saving) && <PartialSpinny />}
            <div className='row2 home-page-header'>
                <div className='col-1'>
                    <Link to='/'> <Button size='large' fillMode='flat' svgIcon={svg.chevronLeftIcon} ></Button></Link>
                </div>
                <div className='col'>
                    <h6>Ticket Monitor ({updateItems?.filter(u => u.Active).length})</h6>
                </div>
                <div className='col text-right'>

                </div>
            </div>
            <ListView className='monitor-listview'
                data={groupBy(updateItems || [], [{ field: 'Type' }])}
                style={{ maxHeight: '100vh', overflowY: 'auto' }}
                item={(props) => {
                    let groupItemItem = props.dataItem;
                    let items = groupItemItem.items;
                    let groupName = groupItemItem.value;


                    return (<>
                        <div className='item-header'>
                            <h5>{groupName}</h5>
                        </div>
                        {items.map((item: IMonitor) => (
                            <Button fillMode='flat' className='row monitor-item' onClick={() => {
                                itemClicked(item);
                            }}>
                                <div className='row' key={item.Id}>
                                    <div className='col-1'>
                                        <input type="checkbox" checked={item.Active} onChange={() => null} />
                                    </div>
                                    <div className='col-11 d-flex align-items-start'>
                                        <span>{item.Display}</span>
                                    </div>
                                </div>
                            </Button>
                        ))}
                    </>
                    )
                }
                }

            />
            <div className='footer'>
                <Button size='large' disabled={updateItems?.filter(u => u.HasChanged).length === 0} svgIcon={svg.saveIcon} style={{ backgroundColor: profile?.Nav_Hex_Color, color: '#fff' }} onClick={onSave}>Save</Button>
                <Button size='large' svgIcon={svg.cancelIcon} fillMode='outline' onClick={onCancel} >Cancel</Button>
            </div>
        </div>


    );
}

export default TicketMonitor;